import { Server } from "lucide-react";
import { SiAnthropic, SiGooglegemini } from "@icons-pack/react-simple-icons";
import { cn } from "@nexus/ui";
import type { PromptLlmModelProvider } from "@nexus/contracts";

interface PromptModelProviderIconProps {
  provider: PromptLlmModelProvider | "service";
  className?: string;
}

/** Brand glyphs for LLM providers (Simple Icons) — never emoji. */
export function PromptModelProviderIcon({
  provider,
  className,
}: PromptModelProviderIconProps) {
  const iconClass = cn("size-3.5 shrink-0", className);

  if (provider === "anthropic") {
    return (
      <SiAnthropic
        className={cn(iconClass, "text-foreground")}
        aria-hidden
        title=""
      />
    );
  }
  if (provider === "google") {
    return (
      <SiGooglegemini
        className={cn(iconClass, "text-violet")}
        aria-hidden
        title=""
      />
    );
  }
  return <Server className={cn(iconClass, "text-muted-foreground")} aria-hidden />;
}
